(function () {
    'use strict';

    angular
        .module('appback')
        .controller('CameraviewController', CameraviewController)

    CameraviewController.$inject = ["$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "$interval", "$scope"];

    function CameraviewController($http, $timeout, $uibModal, $log, $document, $sce, $interval, $scope) {

        var vm = this;
        vm.camera = '';
        vm.imageUrl = false;
        vm.line = '';
        vm.phase = '';

        vm.cameras = window.cameras || {};
        vm.images = {};

        // Función para refrescar la URL agregando un timestamp único
        vm.updateFrames = function () {
            angular.forEach(vm.cameras, function (cams) {

                angular.forEach(cams, function (cam) {

                    vm.images[cam.code_camera] =
                        '/backend/camera/readimage?camera=' +
                        cam.code_camera +
                        '&cache=' +
                        Date.now();
                });
            });
        };

        // Inicializar la primera carga
        vm.updateFrames();

        // Configurar el intervalo para actualizar cada 1000 ms (1 segundo)
        var timer = $interval(vm.updateFrames, 1000);

        // Cancelar el intervalo cuando el controlador se destruya para evitar fugas de memoria
        $scope.$on('$destroy', function () {
            if (angular.isDefined(timer)) {
                $interval.cancel(timer);
            }
        });

        vm.initSingleCamera = function (camera) {

            vm.camera = camera;
            vm.images = {};

            vm.updateFrame = function () {
                vm.images[vm.camera] =
                    '/backend/camera/readimage?camera=' +
                    vm.camera +
                    '&cache=' +
                    Date.now();
            };

            vm.updateFrame();

            var timer = $interval(vm.updateFrame, 1000);

            $scope.$on('$destroy', function () {
                $interval.cancel(timer);
            });
        };
    }
})();